import sanitizeHtml from "sanitize-html";

const ALLOWED_TAGS = [
  // Block elements
  "div",
  "p",
  "blockquote",
  "pre",
  "hr",
  "br",
  // Headings
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  // Inline elements
  "span",
  "a",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "code",
  "small",
  "sub",
  "sup",
  // Lists
  "ul",
  "ol",
  "li",
  // Tables
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "td",
  "th",
  "caption",
  // Media
  "img",
];

const STYLE_CLASS_AND_DIR = ["style", "class", "dir"];

export const sanitizeZendeskHTMLContent = (html: string) =>
  sanitizeHtml(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
      "*": STYLE_CLASS_AND_DIR,
      a: ["href", "target", "rel", ...STYLE_CLASS_AND_DIR],
      img: ["src", "alt", "width", "height", ...STYLE_CLASS_AND_DIR],
      td: ["colspan", "rowspan", ...STYLE_CLASS_AND_DIR],
      th: ["colspan", "rowspan", "scope", ...STYLE_CLASS_AND_DIR],
    },
    transformTags: {
      // Unwrap the Zendesk comment wrapper div, keeping its children
      div: (tagName, attribs) => {
        if (attribs.class?.includes("zd-comment")) {
          return { tagName: "div", attribs: {} };
        }
        return { tagName, attribs };
      },
      a: (tagName, attribs) => {
        const href = attribs.href || "";
        if (href.startsWith("http://") || href.startsWith("https://")) {
          return {
            tagName,
            attribs: {
              ...attribs,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          };
        }
        return { tagName, attribs };
      },
    },
    allowedSchemesByTag: {
      img: ["http", "https", "data"],
      a: ["http", "https", "mailto", "tel"],
    },
  });
